import React from 'react'
import PropTypes from 'prop-types'
import { Row, Column } from '@sainsburys-tech/bolt'

const CategoryNavigation = ({ children, name, dataTest, index }) => (
  <Row data-test={`${dataTest}-categoryNav-container-${index}`} row='xs' key={name} gutterValue={0}>
    <Column data-test={`${dataTest}-categoryNav-subheading`} as='h4' xs={12} gutterValue={1} gutterSize='30px'>
      {name}
    </Column>

    {[...children]}
  </Row>
)

CategoryNavigation.propTypes = {
  /** Optional array of children categories in the navigation container */
  children: PropTypes.array,
  /** Oprional text for category navigation name */
  name: PropTypes.string
}

export default CategoryNavigation
